/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon91IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon91Icon(props: Icon91IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 12 12"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M10.293 1.293 4 7.586 1.707 5.293A1 1 0 0 0 .293 6.707l3 3a1 1 0 0 0 1.414 0l7-7a1 1 0 0 0-1.414-1.414"
        }
      ></path>
    </svg>
  );
}

export default Icon91Icon;
/* prettier-ignore-end */
